<template>
  <div style="width: 1000px;">
    <Button class="sav-btn" @click="save" >确认</Button>
    <Button class="cancel-btn" @click="cancel">取消</Button>
    <div>
      
    </div>
    <iframe 
      :src="mapUrl"
      width="100%"
      height="600px"
      frameborder="0"
      allowfullscreen
    ></iframe>
  </div>

</template>
 
<script>
import StrUtil from '@/common/js/util'
import PubUtil from '@/common/js/publicMethods'

export default {
  name: "SubIframe",
  data() {
    return {
      subData : null,
      mapUrl : '',
      tableId : null,
      tableName : null,
      itemId : null,
      userId : null,
      location : null,
      address : null
    };
  },
  created() {
    const { tableName, tableId, itemId } = this.$router.currentRoute.params;
    this.tableName = tableName;
    this.tableId = tableId;
    this.itemId = itemId;
    this.userId = this.$store.state.global.userInfo.id;
    this.getMapUrl();
    window.addEventListener('message', this.msgListener);
  },
  beforeDestroy() {
    window.removeEventListener('message', this.msgListener);
  },
  methods: {

    save(event) {
      let data = this.subData;
      console.info("address:" + this.address);
      console.info(data);
      if (data == null || data.location == null) {
        this.$Message.error("未获取到正常坐标，请重新选择！");
      	return;
      }
      if(Array.isArray(data.address)){
        data.address = '';
      }
      //  判断原本的地址是否为空 
      if (this.address != null && this.address != '') {
        if(data.address != null && data.address != '' && data.address != undefined) {
          if(confirm("路/街名或详细地址当前值为："+this.address+",是否更新为："+data.address+",如果确认则更新，取消则忽略地址更新")){
            this.address = data.address;
          }else {
            this.address = null;
          }
        }else {
          this.address = null;
        }
      }else {
        this.address = data.address;
      }
      let userInfo = this.$store.state.global.userInfo;
      console.info("userInfo:" + userInfo);
      const params = {
        table: this.tableName,
        tableId: this.tableId,
        objid: this.itemId,
        address: this.address,
        location: data.location,
        user: {
          userId: userInfo.id,
          userName: userInfo.name,
          userEName: userInfo.ename,
          clientId: userInfo.userenv.$AD_CLIENT_ID$,
          orgId: userInfo.userenv.$AD_ORG_ID$
        }
      };
      //  
      this.$network.post("/p/cs/saveLocation", params).then((res) => {
        if (res.data.data.code == 0) {
          this.$Modal.fcSuccess({
            title: "成功",
            content: "保存成功",
          });
          document.querySelector('#refresh').click();
          this.$emit("closeActionDialog", false); // 关闭弹框
        } else {
          this.$Modal.fcError({
            title: "失败",
            content: res.data.data.message,
          });
        }
      }); 
    },

    msgListener(event) {
      this.subData = event.data;
    },
    openIframe(url) {
      PubUtil.openIframe(url);
    }, 
    /**
     * 获取对接地图的地址，地址保存在Apollo中
     */
    getMapUrl() {
      //document.querySelector('.ark-modal-content-drag').computedStyleMap.width = '1400px';
      const params = {
        table: this.tableName,
        tableId: this.tableId,
        objid: this.itemId,
      };
      this.$network.post("/p/cs/getMapUrl", params).then((res) => {
        console.info(res);
        if (res.data.data.code == 0) {
          this.mapUrl = res.data.data.data.url;
          this.address = res.data.data.data.address;
        } else {
          this.$Modal.fcError({
            title: '失败',
            content: res.data.data.message
          });
          this.$emit("closeActionDialog", false); 
        }
      });
    },
    
    /**
     * 取消
     */
    cancel() {
      this.$emit("closeActionDialog", false); // 关闭弹框
    }

  }
};
</script>
